module.exports = __webpack_public_path__ + "static/media/col3.ed122cc6.svg";